export const themes = {
  light: {
    '--bg-primary': '#E4E4E4',
    '--bg-secondary': '#FFF',
    '--bg-tertiary': '#F9FAFB',
    '--primary-text': '#000',
    '--secondary-text': '#1a1a1a',
    '--tertiary-text': '#364153',
    '--text-opp': '#FFF',
    '--primary-icon-color': '#4A5565',
    '--secondary-icon-color': '#6A7282',
    '--tertiary-icon-color': '#787878',
    '--primary-border': '#E5E7EB',
    '--secondary-border': '#A1A1A1',
    '--header-background': '#579DD2',
    '--header-icon-bg': '#F2F2F2',
    '--header-icon-color': '#4A5565',
    '--header-error-icon-color': '#FF484B',
    '--header-notification-count-bg': '#FFF',
    '--header-toggle-pill-bg': '#FFF',
    '--header-toggle-pill-border': '#F2F2F2',
    '--header-toggle-checkmark-bg': '#266CA1',
    '--input-bg': '#F2F2F2',
    '--input-border': '#d9e4ff',
    '--input-placeholder-color': '#364153',
    '--multiselect-bg': '#F2F2F2',
    '--multiselect-selected-bg': '#C4DEFF',
    '--multiselect-value-pill-border': '#1A1A1A',
    '--multiSelect-menu-bg': '#ffffffff',
    '--multiSelect-menu-border': '#d9e4ff',
    '--multiSelect-options-text': '#364153',
    '--multiSelect-checkbox-border': 'rgba(12, 12, 12, 1)',
    '--table-header-bg': '#F3F4F6',
    '--table-header-border-bottom': '#D5D5D5',
    '--table-header-text': '#4A5565',
    '--table-row-bg1': '#FFF',
    '--table-row-bg2': '#FFF',
    '--table-border-bottom': '#DBDBDB',
    '--table-body-text': '#1E2939',
    '--table-selected-row-bg': '#eff6ff',
    '--timer-bg': '#F3F4F6',
    '--timer-text': '#1E2939',
    '--timer-text-red': '#C00',
    '--timer-text-yellow': '#CED100',
    '--timer-text-orange': '#C27B00',
    '--timer-border': '#BDBDBD',
    '--partial-paid-chip-bg': '#E0A717',
    '--partial-paid-chip-border': '#B38000',
    '--unpaid-chip-bg': '#D05658',
    '--unpaid-chip-border': '#780002',
    '--paid-chip-bg': 'rgba(75, 147, 68, 0.80)',
    '--paid-chip-border': '#3F8738',
    '--status-pending-chip-bg': '#00A2D7',
    '--status-pending-chip-border': '#00607F',
    '--status-inprogress-chip-bg': '#E0A717',
    '--status-inprogress-chip-border': '#B38000',
    '--status-complete-chip-bg': '#6FA969',
    '--status-complete-chip-border': '#3F8738',
    '--status-error-chip-bg': '#D05658',
    '--status-error-chip-border': '#780002',
    '--checkdetail-checknumber-text': '#2951DE',
    '--checkdetail-small-text': '#6A7282',
    '--checkdetail-header-text': '#000',
    '--checkdetail-iconbox-bg': '#E5E7EB',
    '--checkdetail-horizontal-stroke': '#C1C1C1',
    '--checkdetail-item-text': '#101828',
    '--checkdetail-tile-bg': '#EFF3FF',
    '--checkdetail-note-bg': '#C3D8FF',
    '--counter-bg': '#FFF',
    '--counter-item-bg': '#F3F4F6',
    '--counter-item-border': '#E5E7EB',
    '--counter-count': '#000',
    '--counter-counter-label': '#6A7282',
    '--counter-active-border': '#135E97',
    '--counter-active-bg': '#D8EEFF',
    '--primary-btn-bg': '#C4DEFF',
    '--primary-btn-border': '#C5CACE',
    '--primary-btn-text': '#000',
    '--primary-btn-disabled': '#9f9f9f',
    '--secondary-btn-border': '#579DD2',
    '--secondary-btn-text': '#101828',
    '--card-bg': '#F6F6F6',
    '--notify-guest-bg': '#F9FAFB',
    '--notify-guest-border': '#E5E7EB',
    '--selected-tile-border': '#615FFF',
    '--selected-tile-background': '#EAEEFF',
    '--secondary-table-header-bg': '#F3F4F6',
    '--secondary-table-header-border': '#3B3E4E',
    '--popup-body-bg': '#fff',
    '--popup-body-border': '#aaaaaa',
    '--primary-input-bg': '#FDFDFD',
    '--primary-input-border': '#D1D5DC',
    '--primary-input-text': '#000',
    '--secondary-search-input-bg': '#EAEAEA',
    '--secondary-search-input-border': 'transparent',
    '--notification-table-header-bg': '#fff',
    '--notification-table-header-text': '#1a1a1a',
    '--notification-body-tile-bg': '#FEFEFE',
    '--notification-action-button-border': '#C5CACE',
    '--notification-action-button-bg': '#C4DEFF',
    '--tileview-header-bg': '#fff',
    '--tileview-body-bg': '#F3F4F6',
    '--primary-selection-color': '#579DD2',
    '--order-status-types-bg': '#bed7ff',
    '--order-status-wrapper-bg': '#ececec',
    '--order-status-tile-border': '#d7d6d6eb',
    '--secondary-toggle-bg': '#F2F2F2',
    '--secondary-toggle-slider-bg': '#266CA1',
    '--cubby-section-bg': '#FFF',
    '--cubby-tile-bg': '#E4E4E4',
    '--cubby-tile-border': '#D2D2D2',
    '--cubby-tile-header-bg': '#FAFAFA',
    '--cubby-tile-overlay-bg': '#c1c1c1ba',
    '--cubby-tile-overlay-content': '#fff',
    '--header-tabs-selected-bg': '#D8EEFF',
    '--header-tabs-selected-border': '#135E97',
    '--header-tabs-selected-text': '#000',
    '--header-tabs-unselected-bg': '#E4E4E4',
    '--header-tabs-unselected-border': '#135E97',
    '--outofstock-item-bg': '#FFDADA',
    '--outofstock-item-border': '#FFA2A2',
    '--oos-selected-item-bg': '#E7EDFF',
    '--oos-delete-icon': '#6f6969',
    '--oos-datePicker-bg': '#FDFDFD',
    '--calender-bg': '#F9FAFB',
    '--selected-date-bg': '#579DD2',
    '--selected-date-text': '#fff',
    '--about-bg': '#FFF',
    '--about-label': '#3A3A3A',
    '--bulk-text-to-pay-header-bg': '#fff',
    '--bulk-text-to-pay-header-text': '#000',
    '--bulk-text-to-pay-input-bg': '#E4E4E4',
    '--hamburger-bg': '#FFF',
    '--hamburger-text': '#1a1a1ae6',
    '--hamburger-border': '#A1A1A1',
    '--react-select-small-text': '#1A1A1A',
    '--react-select-bg': '#C4DEFF',
    '--react-select-text': '#1A1A1A',
    '--react-select-menu-bg': '#ffffff',
    '--react-select-selected-option': '#d0d1d3ff',
    '--assign-emp-primary-search': '#FDFDFD',
    '--assign-emp-filter-btn-bg': '#CCC',
    '--assign-emp-card-bg': '#ffffff',
    '--assign-emp-card-text': '#1A1A1A',
    '--assign-emp-slot-bg': '#f2f2f2',
    '--assign-emp-minus-icon': '#96AEFF',
    '--assign-emp-selected-card-bg': '#9f9f9f91',
    '--assign-emp-selected-card-text': '#1a1a1a',
    '--assign-emp-selected-cardname-bg': '#96AEFF',
    '--assign-emp-selected-cardname-text': '#FFF',
    '--sensor-delete-icon': '#C4DEFF',
    '--nameSensor-input-bg': '#EFEFEF',
    '--sensor-group-bg': '#F2F2F2',
    '--sensor-code-bg': '#BEBEBE',
    '--group-view-bar': '#dbdbdb',
    '--tile-group-view-bar': '#b7b7b7',
    '--tile-group-view-noData': '#fff',
    '--checkedin-chip-bg': '#83A6ED',
  },
  dark: {
    '--bg-primary': '#111315',
    '--bg-secondary': '#292929b3',
    '--bg-tertiary': '#111315',
    '--primary-text': '#FFF',
    '--secondary-text': '#ffffff',
    '--tertiary-text': '#FFF',
    '--text-opp': '#000',
    '--primary-icon-color': '#FFF',
    '--secondary-icon-color': '#FFF',
    '--tertiary-icon-color': '#838383',
    '--primary-border': 'transparent',
    '--secondary-border': '#3B3E4E',
    '--header-background': '#524e67',
    '--header-icon-bg': '#292929b3',
    '--header-icon-color': '#fff',
    '--header-error-icon-color': '#C50000',
    '--header-notification-count-bg': '#c7d8ff',
    '--header-toggle-pill-bg': '#222323',
    '--header-toggle-pill-border': '#c7d8ff',
    '--header-toggle-checkmark-bg': '#C7D8FF',
    '--input-bg': '#363636',
    '--input-border': '#646464',
    '--input-placeholder-color': 'rgba(234, 234, 234, 0.90)',
    '--multiselect-bg': '#333',
    '--multiselect-selected-bg': '#424962',
    '--multiselect-value-pill-border': '#FFF',
    '--multiSelect-menu-bg': '#2d2b30',
    '--multiSelect-menu-border': '#4a484a',
    '--multiSelect-options-text': '#E6E1E5',
    '--multiSelect-checkbox-border': '#B6B6B6',
    '--table-header-bg': '#383c3d',
    '--table-header-border-bottom': '#3b3e4e',
    '--table-header-text': '#cccaca',
    '--table-row-bg1': '#1E1E1E',
    '--table-row-bg2': '#262626',
    '--table-border-bottom': '#3b3e4e',
    '--table-body-text': '#FFF',
    '--table-selected-row-bg': '#34436e',
    '--timer-bg': '#4e4d4d',
    '--timer-text': '#FFF',
    '--timer-text-red': '#ff0000',
    '--timer-text-yellow': '#ffff00',
    '--timer-text-orange': '#ffa500',
    '--timer-border': 'none',
    '--partial-paid-chip-bg': '#e3ce3be6',
    '--partial-paid-chip-border': '#e3ce3be6',
    '--unpaid-chip-bg': '#e44f4fcc',
    '--unpaid-chip-border': '#C50000',
    '--paid-chip-bg': '#3F8738',
    '--paid-chip-border': '#3F8738',
    '--status-pending-chip-bg': 'rgba(255, 158, 81, 0.30)',
    '--status-pending-chip-border': '#FF9E51',
    '--status-inprogress-chip-bg': 'rgba(214, 201, 81, 0.30)',
    '--status-inprogress-chip-border': '#D6C951',
    '--status-complete-chip-bg': 'rgba(46, 125, 50, 0.30)',
    '--status-complete-chip-border': '#63A770',
    '--status-error-chip-bg': 'rgba(255, 108, 110, 0.3)',
    '--status-error-chip-border': '#FF6C6E',
    '--checkdetail-checknumber-text': '#c7d8ff',
    '--checkdetail-small-text': '#a0a0a0',
    '--checkdetail-header-text': '#ffffffe6',
    '--checkdetail-iconbox-bg': '#444',
    '--checkdetail-horizontal-stroke': '#444',
    '--checkdetail-item-text': '#ffffffe6',
    '--checkdetail-tile-bg': '#444',
    '--checkdetail-note-bg': '#fff',
    '--counter-bg': '#444',
    '--counter-item-border': '#646464',
    '--counter-item-bg': '#262626',
    '--counter-count': '#bca4e3',
    '--counter-counter-label': '#FFF',
    '--counter-active-border': '#424962',
    '--counter-active-bg': '#424962',
    '--primary-btn-bg': '#5a658fff',
    '--primary-btn-border': '#96aeff',
    '--primary-btn-text': '#fff',
    '--primary-btn-disabled': '#424962',
    '--secondary-btn-border': '#96AEFF',
    '--secondary-btn-text': '#eaeaeae5',
    '--card-bg': '#4444444d',
    '--notify-guest-bg': '#353535',
    '--notify-guest-border': '#3b3e4e',
    '--selected-tile-border': '#96AEFF',
    '--selected-tile-background': '#424962',
    '--secondary-table-header-bg': '#353535',
    '--secondary-table-header-border': '#3B3E4E',
    '--popup-body-bg': '#252629',
    '--popup-body-border': '#252629',
    '--primary-input-bg': '#383838',
    '--primary-input-border': 'transparent',
    '--primary-input-text': '#F4EFF4',
    '--secondary-search-input-bg': '#363636',
    '--secondary-search-input-border': '#646464',
    '--notification-table-header-bg': '#474747',
    '--notification-table-header-text': '#fff',
    '--notification-body-tile-bg': '#2f3445',
    '--notification-action-button-border': '#9A9A9A',
    '--notification-action-button-bg': '#424962',
    '--tileview-header-bg': '#ededed33',
    '--tileview-body-bg': '#1e1e1e',
    '--primary-selection-color': '#96aeff',
    '--order-status-types-bg': '#bed7ff',
    '--order-status-wrapper-bg': '#262626',
    '--order-status-tile-border': '#4A4A4A',
    '--secondary-toggle-bg': '#000',
    '--secondary-toggle-slider-bg': '#fff',
    '--cubby-section-bg': '#222323',
    '--cubby-tile-bg': '#1E1E1E',
    '--cubby-tile-border': '#3F3F3F',
    '--cubby-tile-header-bg': '#7f7f7f',
    '--cubby-tile-overlay-bg': '#eaeaeae6',
    '--cubby-tile-overlay-content': '#000',
    '--header-tabs-selected-bg': '#C7D8FF',
    '--header-tabs-selected-border': '#96AEFF',
    '--header-tabs-selected-text': '#000',
    '--header-tabs-unselected-bg': '#2C2B30',
    '--header-tabs-unselected-border': '#5A5B5E',
    '--outofstock-item-bg': '#724546',
    '--outofstock-item-border': '#96AEFF',
    '--oos-selected-item-bg': '#525972',
    '--oos-delete-icon': '#96AEFF',
    '--oos-datePicker-bg': '#2d2d2d',
    '--calender-bg': '#333',
    '--selected-date-bg': '#fff',
    '--selected-date-text': '#000',
    '--about-bg': '#222323',
    '--about-label': '#bcbcbc',
    '--bulk-text-to-pay-header-bg': '#353535',
    '--bulk-text-to-pay-header-text': '#cccaca',
    '--bulk-text-to-pay-input-bg': '#383838',
    '--hamburger-bg': '#292929',
    '--hamburger-text': '#ffffffe6',
    '--hamburger-border': '#444',
    '--react-select-small-text': '#b6b6b6',
    '--react-select-bg': '#3D4142',
    '--react-select-text': '#ffffff',
    '--react-select-menu-bg': '#1E1E1E',
    '--react-select-selected-option': '#96aeff80',
    '--assign-emp-primary-search': '#363636',
    '--assign-emp-filter-btn-bg': '#222323',
    '--assign-emp-card-bg': '#1E1E1E',
    '--assign-emp-card-text': '#eaeaea',
    '--assign-emp-slot-bg': '#3d3e40',
    '--assign-emp-minus-icon': '#fff',
    '--assign-emp-selected-card-bg': '#96aeff',
    '--assign-emp-selected-card-text': '#fff',
    '--assign-emp-selected-cardname-bg': '#FFF',
    '--assign-emp-selected-cardname-text': '#96aeff',
    '--sensor-delete-icon': 'transparent',
    '--nameSensor-input-bg': '#333',
    '--sensor-group-bg': '#3d3e40',
    '--sensor-group-selected-border': '#96AEFF',
    '--sensor-code-bg': '#111315',
    '--group-view-bar': '#808080',
    '--tile-group-view-bar': '#808080',
    '--tile-group-view-noData': '#000',
    '--checkedin-chip-bg': '#4870ff',

  },
};
